import { useEffect } from "react";
import "../../styles/style_annonce.css";

export default function AnnonceSection({ dataEvents }) {
  useEffect(() => {
    if (dataEvents?.metaData) {
      const style = document.createElement("style");
      style.setAttribute("data-annonce-style", "true");
      style.innerHTML = `.VH_container { min-height: 400px !important; }`;

      document.head.appendChild(style);
    }
  }, []);

  return (
    <section className="annonce_container_full">
      <div className="iframe_wrapper">
        <iframe title="Google Maps Boutique" className="annonce_map_full" src={dataEvents.metaData.google_map_link} allowFullScreen="" loading="lazy" ></iframe>
        <div className="iframe_overlay"></div>
      </div>

      <div className="annonce_overlay">
        <h2 className="annonce_title">{dataEvents.metaData.title}</h2>
        <p className="annonce_text">{dataEvents.metaData.description}</p>
        <button className="annonce_btn" onClick={() => window.open( dataEvents.metaData.btn_1.externalLink, "_blank", "noopener,noreferrer")}>
          {dataEvents.metaData.btn_1.label}
        </button>
      </div>
    </section>
  );
}